import { defineStore } from 'pinia';
import { ref, Ref } from 'vue';
import { IFilterSelectItem } from '@/types/IFilterSelectItem';
// import { useApi } from '@beautybox/core/plugins/request';
import { PriceType } from '@beautybox/core/entity/Services';
import { PRICE_TYPES } from '@/constants';

export const usePricesStore = defineStore('price', () => {
    // const { provider } = useApi();
    const priceTypes = ref([]) as Ref<IFilterSelectItem[]>;

    const getPriceTypes = async () => {
        // TODO запрос на бек заменен подгрзукой типов цен из констант
        // так как на беке иногда падает nginx для поддомена link
        // когда проблема будет решена нужно обратно вернуть запрос на бекенд,
        // и типы и интерфейсы из файла с константами
        const { body = [] } = { ...PRICE_TYPES };
        // await provider
        // .get<IPriceTypeResponse>('/price-types', undefined, 'static')
        // .catch(() => ({
        //     body: [],
        // }));

        priceTypes.value = body.map((priceType) => ({
            value: priceType.alias,
            text: priceType.text,
        }));
    };

    const getPriceTypeByKey = (key: PriceType) => {
        return priceTypes.value.find((priceType) => priceType.value === key);
    };

    return { priceTypes, getPriceTypes, getPriceTypeByKey };
});

export default usePricesStore;
